import { faCalendarCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import React from "react";
import { useIntl } from "react-intl";
import { COLOR_PRIMARY } from "../../../constants/theme";
import { DemoRequestNotification } from "../../../cores/notifications/interfaces/api/get-notifications";

interface Props {
  notification: DemoRequestNotification;
  variant?: "dropdown" | "page";
  isDarkMode?: boolean;
}

export default function DemoRequestNotificationItem({
  notification,
  variant = "dropdown",
  isDarkMode = false,
}: Props) {
  const intl = useIntl();
  const title =
    notification.name ||
    notification.email ||
    intl.formatMessage({ id: "app.notifications.demoRequest.title" });
  const channel = notification.channel
    ? intl.formatMessage({ id: `app.demo.channel.${notification.channel}` })
    : "";
  const subtitleParts = [channel, notification.preferredAt].filter(Boolean);
  const subtitle = subtitleParts.join(" · ");

  if (variant === "page") {
    return (
      <div
        className={cn("new-contact-notification-page", {
          "new-contact-notification-page--dark": isDarkMode,
        })}
      >
        <div className="new-contact-notification-page__icon">
          <FontAwesomeIcon
            icon={faCalendarCheck}
            size="2x"
            color={COLOR_PRIMARY}
          />
        </div>
        <div className="new-contact-notification-page__body">
          <p className="new-contact-notification-page__eyebrow">
            {intl.formatMessage({ id: "app.notifications.kind.demoRequest" })}
          </p>
          <p className="new-contact-notification-page__title">{title}</p>
          {subtitle ? (
            <p className="new-contact-notification-page__success">{subtitle}</p>
          ) : null}
          {notification.email ? (
            <p className="new-contact-notification-page__success">
              {notification.email}
            </p>
          ) : null}
          {notification.message ? (
            <p className="new-contact-notification-page__success">
              {notification.message}
            </p>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex align-items-center border-bottom mb-1">
      <FontAwesomeIcon
        icon={faCalendarCheck}
        className="mr-2"
        size="2x"
        color={COLOR_PRIMARY}
      />
      <div className="d-flex flex-column overflow-hidden">
        <span className="text-truncate">
          {intl.formatMessage({ id: "app.notifications.demoRequest.received" })}
        </span>
        <span className="text-truncate text-secondary">
          {title}
          {subtitle ? ` · ${subtitle}` : ""}
        </span>
      </div>
    </div>
  );
}
